import Model from './Model'
import get from 'lodash/get'
export default class Product extends Model {

    resource()
    {
        return 'products'
    }

    get friendlyType() {
        return get(this.productTypes.find(type => this.type === type.id), 'text', 'Nedefinit')
    }

    get productTypes() {
        return [{
            id: 'PRODUCT',
            text: 'Produs'
        }, {
            id: 'SERVICE',
            text: 'Serviciu'
        }]
    }
}
